import React from 'react';
import styled from 'styled-components';
import { Box, Typography } from '@mui/material';

export type ColorHistoryProps = {
	colors: string[];
	onColorSelect: (color: string) => void;
	currentColor?: string;
};

function ColorHistory({ colors, onColorSelect, currentColor }: ColorHistoryProps) {
	if (colors.length === 0) return null;

	return (
		<Box mb={0.5}>
			<Typography mx={1} mb={1} component="h6" fontWeight={600} fontSize={10} color="#aaa">
				RECENT COLORS
			</Typography>
			<ColorScrollContainer>
				<ColorRow>
					{colors.map((color, index) => (
						<ColorSwatch key={`${color}-${index}`} color={color} isSelected={currentColor === color} onClick={() => onColorSelect(color)} title={color} />
					))}
				</ColorRow>
			</ColorScrollContainer>
		</Box>
	);
}

export default ColorHistory;

const ColorScrollContainer = styled.div`
	overflow-x: auto;
	padding: 0 8px;

	/* Hide scrollbar for cleaner look */
	scrollbar-width: none; /* Firefox */
	-ms-overflow-style: none; /* IE and Edge */
	&::-webkit-scrollbar {
		display: none; /* Chrome, Safari, Opera */
	}
`;

const ColorRow = styled.div`
	display: flex;
	gap: 4px;
	min-width: max-content;
`;

const ColorSwatch = styled.div<{ color: string; isSelected: boolean }>`
	width: 22px;
	height: 22px;
	background-color: ${props => props.color};
	border-radius: 4px;
	border: 2px solid ${props => (props.isSelected ? '#fff' : 'transparent')};
	cursor: pointer;
	transition: all 0.2s ease;
	position: relative;

	&:hover {
		transform: scale(1.2);
		border-color: #fff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
		z-index: 10;
	}

	&:active {
		transform: scale(0.95);
	}

	// Add checkerboard pattern for transparent colors
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-image: linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(-45deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%),
			linear-gradient(-45deg, transparent 75%, #ccc 75%);
		background-size: 6px 6px;
		background-position: 0 0, 0 3px, 3px -3px, -3px 0px;
		border-radius: 2px;
		z-index: -1;
	}
`;
